<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pt-4 pb-2" >
                <v-col sm="8" md="4" class="py-0 my-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('roles.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0 my-0">
                    <v-btn class="right white_highlight--text" color="secondary" :to="'/roles/create'" v-permission="'role.create'">
                        {{ $t('roles.new') }}
                    </v-btn>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :props="{headers:headers, items: props.items, search:props.search}" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
            <v-dialog v-model="modalDelete" persistent max-width="90%">
                <v-card >
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                                <h3 class="text-uppercase">
                                    {{ $t('roles.modal.delete') }}
                                </h3>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="py-3 my-3 text-center">
                            <v-col cols="12">
                                <h5>{{ $t('roles.modal.message') }}</h5>
                            </v-col>
                        </v-row>
                        
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalDelete = false">{{ $t('roles.no') }}</v-btn>
                            <v-btn color="error" @click="deleteRole">
                                {{ $t('roles.yes') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker"></div>
                </v-card>
            </v-dialog>
            </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
import { HttpRoleRepository } from '../infrastructure/repositories/role_repository';
import { rolesIndexUseCase } from '../application/use_cases/roles_index_use_case';
import { rolesDeleteUseCase } from '../application/use_cases/roles_delete_use_case';

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]},
        headers(){
            return [
                { text: this.$t('roles.id'), align: "center", value: 'id', class: 'text-uppercase' },
                { text: this.$t('roles.name'), align: "start", value: 'name', class: 'text-uppercase', width: '70%' },
                { text: this.$t('roles.actions'), align: "center", value: 'actions', class: 'text-uppercase' },
            ];
        } 
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            modalDelete: false,
            idRole: '',
            description: '',
            props: {
                search: '',
                items: [],
            }
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.roles";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async index(){
            try{
                const response = await rolesIndexUseCase(HttpRoleRepository);
                
                this.props.items = response;
            } catch (e) {
                console.log(e.response);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        askDelete(role){
            console.log(role)
            this.modalDelete = true;
            this.idRole = role.id;
        },
        async deleteRole(){
            try{
                const response = await rolesDeleteUseCase(this.idRole, HttpRoleRepository);
                response;
    
                this.modalDelete = false;
                this.index();
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        }
    }
}
</script>
<style>
</style>